/**
 * Google Ads tag (gtag.js) — loaded ONLY on the public offer funnel, never in
 * the authenticated app. All calls are wrapped: a blocked/failed Google script
 * must never break opt-in or booking. The tag ID + conversion send_to labels
 * are public-by-design client IDs (safe in the bundle).
 */
const TAG_ID = import.meta.env.VITE_GADS_TAG_ID || null;

let loaded = false;

export function loadAdsTag() {
  try {
    if (loaded || !TAG_ID || typeof window === 'undefined') return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', TAG_ID);
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(TAG_ID)}`;
    document.head.appendChild(s);
  } catch (err) {
    // Tracking must never break the funnel.
    console.warn('[adsTag] load failed:', err?.message);
  }
}

export function fireConversion(sendTo) {
  try {
    if (!sendTo || typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', { send_to: sendTo });
  } catch (err) {
    console.warn('[adsTag] conversion failed:', err?.message);
  }
}
